import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from "lucide-react";

const links = {
  Services: [
    "Infrastructure Planning",
    "Cybersecurity",
    "Cloud Solutions",
    "Digital Transformation",
    "IT Strategy",
    "Technical Support",
  ],
  Company: ["About Us", "Capabilities", "Case Studies", "Blog", "Careers", "Contact"],
};

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 dark:bg-slate-950 text-slate-400">
      <div className="container mx-auto max-w-7xl px-4 pt-16 pb-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1 space-y-5">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-sky-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">LT</span>
              </div>
              <span className="font-bold text-lg text-white tracking-tight">
                LUXA<span className="text-sky-400">-TECH</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              Empowering businesses with cutting-edge IT solutions since 2009. Your trusted partner
              for digital transformation.
            </p>
            <div className="space-y-2 text-sm">
              <a href="mailto:info@luxe-tek.com" className="flex items-center gap-2 hover:text-sky-400 transition-colors">
                <Mail className="h-4 w-4" /> info@luxe-tek.com
              </a>
              <a href="tel:+18005550192" className="flex items-center gap-2 hover:text-sky-400 transition-colors">
                <Phone className="h-4 w-4" /> +1 (800) 555-0192
              </a>
              <span className="flex items-center gap-2">
                <MapPin className="h-4 w-4" /> New York, NY 10118
              </span>
            </div>
            {/* Social */}
            <div className="flex gap-3">
              {[Linkedin, Twitter, Github].map((Icon, i) => (
                <button
                  key={i}
                  className="w-9 h-9 rounded-lg bg-slate-800 dark:bg-slate-800 hover:bg-sky-500 flex items-center justify-center transition-colors"
                >
                  <Icon className="h-4 w-4 text-slate-400 hover:text-white" />
                </button>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              {links.Services.map((s) => (
                <li key={s}>
                  <button className="hover:text-sky-400 transition-colors text-left">{s}</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              {links.Company.map((s) => (
                <li key={s}>
                  <button className="hover:text-sky-400 transition-colors text-left">{s}</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-white mb-4">Stay Updated</h4>
            <p className="text-sm mb-4 leading-relaxed">
              Get the latest IT insights and industry news delivered to your inbox.
            </p>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex flex-col gap-2"
            >
              <input
                type="email"
                placeholder="your@email.com"
                className="px-4 py-2.5 rounded-xl bg-slate-800 border border-slate-700 text-white text-sm placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-sky-500/50 focus:border-sky-500/50 transition-colors"
              />
              <button
                type="submit"
                className="px-4 py-2.5 rounded-xl bg-sky-500 hover:bg-sky-600 text-white text-sm font-medium transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm">
          <p>© {year} Luxe-Tech. All rights reserved.</p>
          <div className="flex gap-6">
            {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((l) => (
              <button key={l} className="hover:text-sky-400 transition-colors">
                {l}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
